// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3c6b462e","29":"32623672","72":"9e7dbd48","80":"b9f18779","287":"bd1f1b92","475":"8097afff","482":"1b044fbb","487":"10e55cba","535":"8ffd1ad7","723":"63ad3fa7","744":"2a73f477","779":"1f204e28","796":"10429dc1","885":"dc3935a8"}[chunkId] + ".chunk.js";
};